module.exports = __webpack_public_path__ + "img/caret-right-white.3e7996fa.svg";